import styled from 'styled-components';
import {mobileMedia} from '../../../globalVariables/GlobalVariables';

export const banner = styled.div`
    width: 100%;
    min-height: 50px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    padding: 12px 70px;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 400;
    color: #eeeeee !important;
    background-color: #222222;
    border-inline-start: 4px solid #29ace3;
    box-sizing: border-box;

    &,
    & span {
        color: #eeeeee !important;
    }

    ${mobileMedia} {
        padding: 12px 40px 12px 16px;
    }
`;

export const bannerLink = styled.a`
    color: #29ace3 !important;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        color: #5bc4eb !important;
    }
`;

export const scopeList = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 20px;
    width: 100%;
    box-sizing: border-box;
    padding: 4px 70px 12px;

    ${mobileMedia} {
        padding: 4px 16px 12px 40px;
        gap: 8px 14px;
    }
`;

export const scopeRow = styled.label`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    white-space: nowrap;
    cursor: pointer;

    input {
        cursor: pointer;
        flex-shrink: 0;
    }
`;

export const disabledNote = styled.div`
    font-size: 12px;
    color: #888;
    padding: 4px 0;
`;
